import { useToastStore } from "@stores/toastStore";

export const useToaster = () => {
  const addToast = useToastStore((state) => state.addToast);
  return { addToast };
};
